import type { ToolDockGroup } from "./ToolDock";

/** The most buttons a phone's dock shows; past it, the last is "Otras". */
const PHONE_MAX_SLOTS = 4;

/**
 * The groups a phone's dock shows, and the ones its "Otras" sheet holds.
 *
 * Kept in order and split by item, so a group cut in two keeps its caption on
 * both sides.
 */
export function splitForPhone(groups: ToolDockGroup[]): { shown: ToolDockGroup[]; overflow: ToolDockGroup[] } {
    const total = groups.reduce((count, group) => count + group.items.length, 0);
    if (total <= PHONE_MAX_SLOTS) return { shown: groups, overflow: [] };
    let room = PHONE_MAX_SLOTS - 1;
    const shown: ToolDockGroup[] = [];
    const overflow: ToolDockGroup[] = [];
    for (const group of groups) {
        const kept = group.items.slice(0, room);
        const rest = group.items.slice(kept.length);
        room -= kept.length;
        if (kept.length) shown.push({ ...group, items: kept });
        if (rest.length) overflow.push({ ...group, items: rest });
    }
    return { shown, overflow };
}
